<template>
    <DModal
        :title="isCreate ? __('settings.legal_forms.modal.create_modal.title') : __('settings.legal_forms.modal.edit_modal.title')"
        is-confirm
        @confirm="submitForm"
        @close="emit('close-modal')"
    >
        <DCard
            padding
        >
            <DFormRow
                :label="__('settings.legal_forms.form.name')"
                :error="errors.name"
                is-required
                :hint="__('settings.legal_forms.form.name_hint')"
            >
                <DInput
                    id="legal_forms_name"
                    v-model="form.name"
                    :placeholder="__('settings.legal_forms.form.name')"
                />
            </DFormRow>
        </DCard>
    </DModal>
</template>

<script setup>
import { useForm } from '@inertiajs/vue3'
import { route } from '~@/Composables/route'
import { ref } from 'vue'

const props = defineProps({
    legalForm: {
        type: Object,
        default: () => { return {} }
    },
    isCreate: {
        type: Boolean,
        default: false
    }
})

const emit = defineEmits(['close-modal'])

const form = useForm({
    name: props.legalForm?.name ?? null
})

const errors = ref({})

function submitForm () {
    if (props.isCreate) {
        form.post(route('settings.legal-forms.store'), {
            onSuccess: () => {
                emit('close-modal')
            },
            onError: (error) => {
                errors.value = error
            }
        })
    }

    form.patch(route('settings.legal-forms.update', { legal_form: props.legalForm?.id }))
}
</script>
